import * as React from "react";
import { useTranslation } from "../../i18n/custom.i18n";
import i18next from "../../i18n/i18n.config";

import { StationData } from "../../utils/StationData";
// import { Tab } from "../../pages/tab";// TODO: Remove tab
import { Filter } from "./Filter";
import { FilterUtils, useIsDesktop } from "./FilterUtils";
import { LibraryUtils } from "../LibraryContainer/LibraryUtils";
import { StationLib } from "../LibraryContainer/StationLib";


let hash_message = {
    "rdkfilter": window.location.hash,
    "rdkinfo": window.location.search,
};
window.addEventListener("message", (event) => {
    if (!window.Settings.LOCAL_BUILD) {
        if(event.data.hasOwnProperty("rdkfilter")) {
            hash_message = {
                "rdkfilter": event.data.rdkfilter,
                "rdkinfo": event.data.rdkinfo
            }
        }
    }
});

// Init on message for url filters
let tickApplyFilter = null;

// Local search_params instead of window.location.search
// So that we can store search info without resetting the page
let search_params = {};
let stations_list: any = StationData.DATA_ALL;

// Default brand, type, axes filters
let brandFilter: stringBoolMap = {};
Object.keys(StationData.ListAllBrands).forEach(brand => { // Purposely using robot brands and not all brands
    brandFilter[brand] = false
});

let tagFilter: stringBoolMap = {};
Object.keys(StationData.ListAllTags).forEach(tag => {
    tagFilter[tag] = false
});

let applicationFilter: stringBoolMap = {};
Object.keys(StationData.ListAllApplications).forEach(apps => {
    applicationFilter[apps] = false
});

let mechanismFilter: stringBoolMap = {};
Object.keys(StationData.ListAllRobotsTypes).forEach(mechanism => {
    mechanismFilter[mechanism] = false
});

let sizeFilter = {
    "Small": false,
    "Medium": false,
    "Large": false,
};

// Flag to hide tab
const hideTab = window.location.search.includes("HideTab");


export const StationFilter = () => {
    const { t, i18n } = useTranslation();

    // Init state
    const [init, setInit] = React.useState(true);

    // Filter states
    const [brands, setBrands] = React.useState(brandFilter);
    const [tags, setTags] = React.useState(tagFilter);
    const [applications, setApplications] = React.useState(applicationFilter);
    const [mechanism, setMechanism] = React.useState(mechanismFilter);
    const [sizes, setSizes] = React.useState(sizeFilter);

    const [mechanismCounts, setMechanismCounts] = React.useState(
        [StationData.robotMin, StationData.robotMax]
    );
    const [toolCounts, setToolCounts] = React.useState(
        [StationData.toolsMin, StationData.toolsMax]
    );
    const [objectCounts, setObjectCounts] = React.useState(
        [StationData.objectsMin, StationData.objectsMax]
    );

    const [sortFilteredStations, setSortFilteredStations] = React.useState(stations_list);

    // Filter helper states
    const [filterType, setFilterType] = React.useState("instant");
    const [noRobotsMessage, setNoRobotsMessage] = React.useState("");

    // Helper variables
    let filteredStationsCounts = FilterUtils.countCheckboxParameters("station", sortFilteredStations);

    const parameters = {
        "brands": brands,
        "tags": tags,
        "applications": applications,
        "mechanism": mechanism,
        "sizes": sizes,
        "mechanism_counts": mechanismCounts,
        "tool_counts": toolCounts,
        "object_counts": objectCounts,
    };

    const setupFilter = (url_data: any) => {
        if (url_data["rdkinfo"]) {
            let info = url_data["rdkinfo"].replace("%27", "'").split("+").join(" ");

            info.substring(1).split("&").map((param) => {
                param.split("?").map((p) => {
                    let temp = p.split("=");
                    search_params[temp[0]] = temp[1];
                });
            });
        };

        const default_filter_map = {
            "application": applicationFilter,
            "feature": tagFilter,
            "brand": brandFilter,
            "mechanism_type": mechanismFilter,
            "size": sizeFilter,
            "mechanism_count": [StationData.robotMin, StationData.robotMax],
            "tool_count": [StationData.toolsMin, StationData.toolsMax],
            "object_count": [StationData.objectsMin, StationData.objectsMax],
        };
        const filter_set_map = {
            "application": setApplications,
            "feature": setTags,
            "brand": setBrands,
            "mechanism_type": setMechanism,
            "size": setSizes,
            "mechanism_count": setMechanismCounts,
            "tool_count": setToolCounts,
            "object_count": setObjectCounts,
        }
            
        FilterUtils.extractUrlQueryOnMessage("station", url_data["rdkfilter"]);

        // Apply filters
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        if(FilterUtils.extracted_params.hasOwnProperty("name"))
            search_input.value = FilterUtils.extracted_params['name'];

        Object.keys(FilterUtils.extracted_params).map((key) => {
            if(key != "name") {
                editFilterFromUrl(
                    FilterUtils.extracted_params[key],
                    default_filter_map[key],
                    filter_set_map[key]
                );
            }
        });

        setFilterType("instant");
    };

    // onmessage for production version pairs with php
    onmessage = (event: any) => {
        if(event.data.hasOwnProperty("rdkfilter")) {
            setupFilter({
                "rdkfilter": event.data.rdkfilter,
                "rdkinfo": event.data.rdkinfo
            });
        }
    }

    const editFilterFromUrl = (
        extracted_param: any, 
        default_filter: any,
        set_filter: any,
    ) => {
        if(Array.isArray(default_filter)) {
            const [min, max] = [
                parseFloat(extracted_param[0]),
                parseFloat(extracted_param[1])
            ];
            
            set_filter([
                min < default_filter[0] ? default_filter[0] : min,
                max > default_filter[1] ? default_filter[1] : max
            ]);
            setFilterType("instant");

        } else {
            let cloned_filter = structuredClone(default_filter);
            Object.keys(cloned_filter).map((entry) => {
                if(extracted_param.includes(entry.toLowerCase()))
                    cloned_filter[entry] = true;
            });

            set_filter(cloned_filter);
            setFilterType("instant");
        }
    }

    // filter methods
    const applyFilters = () => {
        tickApplyFilter = null;

        if (search_params.hasOwnProperty("oem")) {
            stations_list = {};

            Object.entries(StationData.DATA_ALL).map((item) => {
                const [name, station] = [item[0], item[1]];
                if (station.hasOwnProperty("B")) {
                    for (let brand of station["B"]) {
                        if (search_params["oem"].toLowerCase() == brand.toLowerCase())
                            stations_list[name] = station;
                    }
                }
            });
        };

        let filtered_list: any = stations_list; 
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        if(search_input.value.length > 0)
            filtered_list = LibraryUtils.searchWithItemsList("station", filtered_list) 

        for(const key in parameters) {
            let temp = FilterUtils.applyFiltersToList("station", key, parameters[key], filtered_list);

            if(Object.keys(temp).length > 0)
                filtered_list = temp;

            // If parameter is of type range then take the result even when it's empty
            if([
                "mechanism_counts", 
                "tool_counts", 
                "object_counts",
            ].includes(key) && FilterUtils.rangeFilterChangedFromDefault(key, parameters[key]))
                filtered_list = temp;
        }

        filteredStationsCounts = FilterUtils.countCheckboxParameters("station", filtered_list);

        applyFiltersToUrl();
        setSortFilteredStations(filtered_list);

        if (init) setFilterType("instant");
        else setFilterType("");
    };

    const applyFiltersSchedule = () => {
        if(tickApplyFilter != null) {
            clearTimeout(tickApplyFilter);
        };
        tickApplyFilter = setTimeout(applyFilters, 100);
    };

    const applyFiltersToUrl = () => {
        let hash_str = "";
        let query_symbol = "#filter?";
        let search_input = document.getElementById("search-input") as HTMLInputElement;
        const filter_strings = {
            "application": applications,
            "feature": tags,
            "brand": brands,
            "mechanism_type": mechanism,
            "mechanism_count": mechanismCounts,
            "tool_count": toolCounts,
            "object_count": objectCounts,
            "size": sizes,
        }

        // name
        if(search_input.value.length > 0) {
            hash_str += query_symbol + "name=" + search_input.value.trim().toLowerCase().split(" ").join("+");
            query_symbol = "&";
        }

        // checkbox and slider
        Object.keys(filter_strings).map((string) => {
            let temp_hash = editUrlFilter(
                string, 
                filter_strings[string], 
                query_symbol
            );

            if(temp_hash != undefined) {
                hash_str += temp_hash;
                query_symbol = "&";
            }
        });

        // Only change hash when not init because
        // on init the hash is empty and it will reset
        // the hash to empty, this will make the saved urls
        // with filters not working properly
        if(!init) {
            window.location.hash = hash_str;
            window.parent.postMessage( { "hash": window.location.hash } );
        }
    };

    const editUrlFilter = (
        filter_string: string, 
        filter: any,
        query_symbol: string,
    ) => {
        if(Array.isArray(filter)) {
            let default_ranges = {
                "mechanism_count": [StationData.robotMin, StationData.robotMax],
                "tool_count": [StationData.toolsMin, StationData.toolsMax],
                "object_count": [StationData.objectsMin, StationData.objectsMax],
            }

            if (
                filter[0] > default_ranges[filter_string][0] ||
                filter[1] < default_ranges[filter_string][1]
            )
                return query_symbol + filter_string + "=" + filter[0] + "-" + filter[1];

        } else {
            let checked_values = [];
            Object.keys(filter).map((entry) => {
                if (filter[entry]) {
                    let temp_value = entry.trim().toLowerCase().split(" ").join("-");
                    if(temp_value == "ext.-axis") temp_value = "ext.axis"
                    checked_values.push(temp_value);
                }
            });
            if (checked_values.length > 0) {
                return query_symbol + filter_string + "=" + checked_values.join("+");
            }
        }
    };

    const clearFilters = () => {
        setBrands(brandFilter);
        setTags(tagFilter);
        setApplications(applicationFilter);
        setMechanism(mechanismFilter);
        setSizes(sizeFilter);
        setMechanismCounts([StationData.robotMin, StationData.robotMax]);
        setToolCounts([StationData.toolsMin, StationData.toolsMax]);
        setObjectCounts([StationData.objectsMin, StationData.objectsMax]);
        
        setFilterType("instant");
    };

    const clearSearchParameters = () => {
        (document.getElementById("search-input") as HTMLInputElement).value = "";
       
        applyFilters();
        setFilterType("instant");
    };

    // Brand filter
    const handleInputChangeBrandFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_brand_filter = structuredClone(brands);
        new_brand_filter[e.currentTarget.value] = e.currentTarget.checked;

        setBrands(new_brand_filter);
        setFilterType("instant");
    };

    // Type filter
    const handleInputChangeTagFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_tag_filter = structuredClone(tags);
        new_tag_filter[e.currentTarget.value] = e.currentTarget.checked;
        
        setTags(new_tag_filter);
        setFilterType("instant");
    };

    // Apps filter
    const handleInputChangeApplicationFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_application_filter = structuredClone(applications);
        new_application_filter[e.currentTarget.value] = e.currentTarget.checked;

        setApplications(new_application_filter);
        setFilterType("instant");
    };

    // Mechanism filter
    const handleInputChangeMechanismFilter = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_mechanism_filter = structuredClone(mechanism);
        new_mechanism_filter[e.currentTarget.value] = e.currentTarget.checked;

        setMechanism(new_mechanism_filter);
        setFilterType("instant");
    };

    // Size filter
    const handleInputChangeSize = (e: React.MouseEvent<HTMLInputElement>) => {
        let new_size_filter = structuredClone(sizes);
        new_size_filter[e.currentTarget.value] = e.currentTarget.checked;

        setSizes(new_size_filter);
        setFilterType("instant");
    };

    // Robot filter
    const handleInputChangeRangeMechanismCounts = (values: Array<number>) => {
        setMechanismCounts([values[0], values[1]]);
        setFilterType("delay");
    };

    // Tool filter
    const handleInputChangeRangeTool = (values: Array<number>) => {
        setToolCounts([values[0], values[1]]);
        setFilterType("delay");
    };

    // Object filter
    const handleInputChangeRangeObject = (values) => {
        setObjectCounts([values[0], values[1]]);
        setFilterType("delay");
    };
    
    // Retrieve url filters
    // onload for local and direct production version
    React.useEffect(() => {
        if (init) {
            setupFilter(hash_message);
            setInit(false);
        }
    }, []);

    React.useEffect(() => {
        if(filterType == "delay")
            applyFiltersSchedule()

        else if(filterType == "instant")
            applyFilters();
    });

    const isSticky = useIsDesktop();

    return (
        <>
            {/* <div className="title sticky-top">
                {!hideTab && (
                    <Tab library={"station"} />
                )}
            </div> */}

            <div className="main-container container-fluid">
                <div className="row">
                    <div className="col col-12 col-sm-12 col-lg-3">
                        <div
                            className={`filter-form ${isSticky ? "sticky-top" : ""}`}
                            style={{ 
                                top: isSticky ? (window.Settings.LOCAL_BUILD ? "8rem" : "12.5rem") : undefined,
                                backgroundColor: "rgb(240, 240, 240)" 
                            }}
                        >
                            <div id="search-row">
                                <form id="search-bar">
                                    <input
                                        id="search-input"
                                        type="text"
                                        placeholder={t('library-headers.search-input')}
                                    />
                                    <div id="search-bar-action-btns">
                                        <button
                                            id="search-button"
                                            onClick={(e: React.MouseEvent) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                applyFilters();
                                            }}
                                        >
                                            <img
                                                width="auto"
                                                height="18rem"
                                                alt="Search"
                                                src={window.Paths.STATION_LIB_ASSETS_CDN + "magnifier.png"}
                                            />
                                        </button>
                                    </div>
                                </form>
                            </div>

                            <div className="section-top">
                                <a
                                    className="btn center-block"
                                    style={{ marginLeft: ".5rem" }}
                                    onClick={(e: React.MouseEvent) => {
                                        clearFilters();
                                        clearSearchParameters();
                                    }}
                                >
                                    {t('library-overlays.clearFiltersBtn')}
                                </a>
                            </div>
                            <div className="filters">
                                <Filter 
                                    type = "applications"
                                    title = "filters-stations.applications"
                                    data = {applications}
                                    counts = {filteredStationsCounts}
                                    handler = {handleInputChangeApplicationFilter}
                                    first = {true}
                                />

                                <Filter
                                    type = "tags"
                                    title = "filters-stations.tags"
                                    data = {tags}
                                    counts = {filteredStationsCounts}
                                    handler = {handleInputChangeTagFilter}
                                    first = {false}
                                />

                                {!search_params.hasOwnProperty("oem") && (
                                    <Filter
                                        type = "brands"
                                        title = "filters-stations.brand"
                                        data = {brands}
                                        counts = {filteredStationsCounts}
                                        handler = {handleInputChangeBrandFilter}
                                        first = {false}
                                    />
                                )}

                                <Filter
                                    type = "mechanism-type"
                                    title = "filters-stations.mechanism-type"
                                    data = {mechanism}
                                    counts = {filteredStationsCounts}
                                    handler = {handleInputChangeMechanismFilter}
                                    first = {false}
                                />
                                
                                <Filter
                                    type = "mechanism-count"
                                    title = "filters-stations.mechanism-count"
                                    step = "1"
                                    decimal = "0"
                                    unit = ""
                                    data = {mechanismCounts}
                                    data_default = {[StationData.robotMin, StationData.robotMax]}
                                    handler = {handleInputChangeRangeMechanismCounts}
                                    first = {false}
                                />

                                <Filter
                                    type = "tool-count"
                                    title = "filters-stations.tool-count"
                                    step = "1"
                                    decimal = "0"
                                    unit = ""
                                    data = {toolCounts}
                                    data_default = {[StationData.toolsMin, StationData.toolsMax]}
                                    handler = {handleInputChangeRangeTool}
                                    first = {false}
                                />

                                <Filter
                                    type = "object-count"
                                    title = "filters-stations.object-count"
                                    step = "1"
                                    decimal = "0"
                                    unit = ""
                                    data = {objectCounts}
                                    data_default = {[StationData.objectsMin, StationData.objectsMax]}
                                    handler = {handleInputChangeRangeObject}
                                    first = {false}
                                />

                                <Filter
                                    type = "sizes"
                                    title = "filters-stations.size"
                                    data = {sizes}
                                    counts = {filteredStationsCounts}
                                    handler = {handleInputChangeSize}
                                    first = {false}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col col-12 col-sm-12 col-lg-9">
                        <StationLib
                            noRobotsMessage = {noRobotsMessage}
                            sortFilteredStations = {sortFilteredStations}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
